module.exports = __webpack_public_path__ + "static/starburst-logo-95a5b9b649fba63cf9093e63e4c7ec13.png";